import SprievodnyDokumentAdd from './SprievodnyDokumentAdd';

export default SprievodnyDokumentAdd;
